export default __webpack_public_path__ + "static/media/slide_one.c0549cdc.jpg";